// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'desktop-pencil';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m6.344 14.844.531-3.188M4.75 14.844h2.125M1.031 8.823h9.711m-2.273 2.833H3.156a2.125 2.125 0 0 1-2.125-2.125V3.156a2.125 2.125 0 0 1 2.125-2.125h11.688a2.125 2.125 0 0 1 2.125 2.125v3.719m-.439 4.158-5.405 5.404-2.656.532L9 14.312l5.405-5.404a1.494 1.494 0 0 1 2.125 0 1.494 1.494 0 0 1 0 2.125z'
  />
);

export const viewBox = '0 0 18 18';
